<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
       <!-- DIV GERAR BOLETO -->
        <div class="card p-3" v-if="!loading && !boleto">
          <div class=" pb-3 checkout-corpo mt-1 ">
                <div class="card card-checkout card-pix shadow-sm">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-upc-scan  mt-3"
                          viewBox="0 0 16 16">
                          <path
                            d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
                        </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3 mb-2">Gere o boleto</h6>
                        <!-- <div class="texto-seguranca">O pagamento com Pix leva pouco tempo para ser processado.</div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-checkout card-pix  shadow-sm mt-2">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-upc-scan mt-3"
                            viewBox="0 0 16 16">
                          <path
                            d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
                        </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3 mb-2">Copie ou leia o código de barras</h6>                    
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-checkout card-pix  shadow-sm mt-2">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-currency-dollar mt-3"
                      viewBox="0 0 16 16">
                        <path
                          d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73z" />
                      </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3 mb-2">Pague o valor gerado no seu banco</h6>
                      </div>
                    </div>
                  </div>
                </div>                      
                <div class="card card-checkout card-pix  shadow-sm mt-2">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-envelope mt-3"
                      viewBox="0 0 16 16">
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                        </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3 mb-2">Enviaremos um e-mail com a compra confirmada</h6>
                      </div>
                    </div>
                  </div>
                </div>        
                <div class="mt-2 mb-5 px-3 col-12 d-flex flex-column justify-content-center">
                  <button type="button" class="btn btn_color_system py-2 px-5 mt-4" @click="gerarBoleto2()">
                    GERAR BOLETO
                  </button>
                </div>
          </div>          
        </div>
        <!-- DIV BOLETO -->
        <div class="card p-3" v-if="boleto">
          <div class="row">
            <div class="col">

              <div class="mt-5  text-center">
                <p class="mt-5">
                  <i class="fa-regular fa-circle-check icon-ckeck"></i>
                </p>
                <p class="mt-3" style="font-size:18px;"><strong> Agradecemos pela sua assinatura e esperamos que
                    aproveite muito o nossos serviços.</strong>
                </p>
                <p class="mt-3">

                  O boleto no
                  valor de <strong> R$ {{
                    formatPrice(boleto ?
                      boleto.valorBoleto
                      : 0)
                  }}</strong>,
                  foi gerado. Após o processamento do pagamento os serviços serão liberados para utilização.

                </p>
              </div>

              <div @click="copiarCodigo" class="p-2 text-center mt-3">

                <p>Utilize o número do código de barras para realizar o pagamento da sua assinatura</p>

                <div class="shadow card-codigo-barra mt-2">
                  <span class="m-3 text-success" v-if="copiaSucesso">Código copiado com sucesso.</span>
                  <span class="m-3 text-center mt-2"> <strong>{{ mascaraBoleto(linhaDigitavel) }}</strong> </span>
                  <input style="opacity: 0; height: 0" id="linhaDigitavel" :value="linhaDigitavel" />
                </div>

                <div class="row mt-3">
                  <div class="col" style="cursor: pointer" @click="copiarCodigo">
                    <i class="fa-solid fa-clone icon"></i><br />copiar
                  </div>

                  <div class="col" style="cursor: pointer" @click="baixarPdf">
                    <i class="fa-solid fa-download icon"></i><br />baixar
                  </div>
                </div>

              </div>

              <!-- <div class="row m-3">
                <div class="col">
                  <span>vencimento </span><strong>{{ dataVencimento }}</strong>
                </div>
              </div>
              <div class="row m-3">
                <div class="col">
                  <span>valor </span><strong>R$ {{ formatPrice(boleto ? boleto.valorBoleto : 0) }}</strong>
                </div>
              </div> -->

              <div class="row  mt-4">
                <span class="col text-center icon-seguro">
                  <i class="fa-solid fa-lock"></i>
                  <span class="ml-1"> Ambiente seguro</span>

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="erro" class=" row  col-12  my-2 badge-danger text-center p-3 text-uppercase mt-3">
        {{ erro }}
      </div>

      <!-- <Loading v-if="loading" :textoMensagem="mensagemLoading"></Loading> -->

    </div>
    <Loading v-if="loading" :textoMensagem="mensagemLoading"></Loading>
  </div>
</template>

<script>

import icons from "@/shared/components/SvgIcon.js";
import { APIService } from "../../APIService";
import moment from "moment";
import Loading from "@/components/Loading.vue";

const apiService = new APIService();

export default {
  name: "CheckoutCartao",
  components: {Loading},
  props: [],
  data() {
    return {
      icons,
      copiaSucesso: false,
      linhaDigitavel: "00000000000000000000000000000000000000000000000000000",
      urlPdf: null,
      dataVencimento: null,
      erroBoleto: null,
      boleto: null,
      detailRecorrencia: null,
      plano: null,
      erro: null,
      mensagemLoading: "",
      loading: false,
      modeloCobranca: null
    };
  },
  mounted() {
    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }

    if (!this.boleto) {
      // this.gerarBoleto();
      // this.loadDetailRecorrencia();
    }
  },
  methods: {
    copiarCodigo() {
      document.getElementById("linhaDigitavel").select();
      document.execCommand("copy");
      this.copiaSucesso = true;
      setTimeout(() => {
        this.copiaSucesso = false;
      }, 20000);
    },
    mascaraBoleto(data) {
      const numeroBoleto = [
        data.slice(0, 5),
        ".",
        data.slice(5, 10),
        " ",
        data.slice(10, 15),
        ".",
        data.slice(15, 21),
        " ",
        data.slice(21, 26),
        ".",
        data.slice(26, 32),
        " ",
        data.slice(32, 33),
        " ",
        data.slice(33),
      ];
      return numeroBoleto.join("");
    },
    baixarPdf() {
      window.open(this.urlPdf, '_blank');
    },
    gerarBoleto() {

      apiService
        .obterBoletoPagamentoRecorrente(this.plano.recorrenciaId)
        .then((res) => {

          this.boleto = res;
          this.linhaDigitavel = this.boleto.linhaDigitavel;
          this.btnloading = false;
          this.urlPdf = res.urlPdf;
          this.dataVencimento = this.boleto.dataVencimento
            ? moment(this.boleto.dataVencimento).format("MM/DD/yyyy")
            : null;

        })
        .catch((error) => (this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title))
    },
    gerarBoleto2() {
      this.loading = true;
      this.mensagemLoading = "Estamos gerando o seu BOLETO. Por favor, aguarde um momento.";
      this.modeloCobranca = this.plano.metodoPagamento.find(metodo => metodo.formaPagamento === "BOLETO");

      apiService
        .gerarPagamento(this.plano.planoId, this.modeloCobranca.modeloCobrancaId)
        .then((resPagamentoId) => {

        apiService
          .obterPagamentoBoleto(resPagamentoId.result.id)
          .then((resBoleto) => {

            this.boleto = resBoleto;
            this.linhaDigitavel = this.boleto.linhaDigitavel;
            this.btnloading = false;
            this.urlPdf = resBoleto.urlPdf;
            this.dataVencimento = this.boleto.dataVencimento
              ? moment(this.boleto.dataVencimento).format("MM/DD/yyyy")
              : null;

              this.loading = false;
          })
          .catch((error) => (
              this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title,
              this.loading = false
            ));
        })
        .catch((error) => (
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title,
          this.loading = false
        ));
      
    },
    loadDetailRecorrencia() {
      apiService
        .obterDetalhePagamentoRecorrente(this.plano.recorrenciaId)
        .then((response) => {
          this.detail = response;

        }).catch((error) => {
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;

        })
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif
}

.container {
  margin: 30px auto;
}

.container .card {
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background: #fff;
  border-radius: 0px;
}

body {
  background: #eee
}



.btn.btn-primary {
  background-color: #ddd;
  color: black;
  box-shadow: none;
  border: none;
  font-size: 20px;
  width: 100%;
  height: 100%;
}

.btn.btn-primary:focus {
  box-shadow: none;
}

.container .card .img-box {
  width: 80px;
  height: 50px;
}

.container .card img {
  width: 100%;
  object-fit: fill;
}

.container .card .number {
  font-size: 24px;
}

.container .card-body .btn.btn-primary .fab.fa-cc-paypal {
  font-size: 32px;
  color: #3333f7;
}

.fab.fa-cc-amex {
  color: #1c6acf;
  font-size: 32px;
}

.fab.fa-cc-mastercard {
  font-size: 32px;
  color: red;
}

.fab.fa-cc-discover {
  font-size: 32px;
  color: orange;
}

.c-green {
  color: green;
}

.box {
  height: 40px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ddd;
}

.btn.btn-primary.payment {
  background-color: #1c6acf;
  color: white;
  border-radius: 0px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}


.form__div {
  height: 50px;
  position: relative;
  margin-bottom: 24px;
  margin-left: 10px;
}

.form-control {
  width: 100%;
  height: 45px;
  font-size: 14px;
  border: 1px solid #DADCE0;
  border-radius: 0;
  outline: none;
  padding: 2px;
  background: none;
  z-index: 1;
  box-shadow: none;
}

.form__label {
  position: absolute;
  left: 16px;
  top: 10px;
  background-color: #fff;
  color: #80868B;
  font-size: 16px;
  transition: .3s;
  text-transform: uppercase;
}

.form-control:focus+.form__label {
  top: -8px;
  left: 12px;
  color: #1A73E8;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.form-control:not(:placeholder-shown).form-control:not(:focus)+.form__label {
  top: -8px;
  left: 12px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.form-control:focus {
  border: 1.5px solid #1A73E8;
  box-shadow: none;
}

.icon-seguro {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}


.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 35px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}

.icon-ckeck {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 56px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}

.card-selecionado {
  border-color: var(--cor-principal);
}

.card-cartao {
  max-width: 350px;
}

.card-codigo-barra {
  background-color: #eee;
  min-width: 90%;
  min-height: 150px;
  border-radius: 7px;
  display: inline-grid;
  flex-wrap: wrap;
  align-content: center;
  margin-left: 5%;
}
</style>
